import { render, staticRenderFns } from "./OneFooter.vue?vue&type=template&id=55f4347c&scoped=true&lang=pug&"
import script from "./OneFooter.vue?vue&type=script&lang=ts&"
export * from "./OneFooter.vue?vue&type=script&lang=ts&"
import style0 from "./OneFooter.vue?vue&type=style&index=0&id=55f4347c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4347c",
  null
  
)

export default component.exports